import type { PoiInfo, PoiInfoList } from '../interfaces';
import { ActivityPopup } from './ActivityPopup';
import { AvinorPopup } from './AvinorPopup';
import { DefaultPopup } from './DefaultPopup';
import { EducationPopup } from './EducationPopup';
import { ShoppingPopup } from './ShoppingPopup';
import { TransportPopup } from './TransportPopup';
import { PoiTypes } from '../poiTypes';

import './popup.css';
import { MAP_API_PATH } from '../poiConfig';

const replaceMapApiUrl = (url?: string): string =>
    url?.replace('https://maptiles.finncdn.no', MAP_API_PATH)?.replace('https://dev.kart.finn.no', MAP_API_PATH) ?? '';

export type PopupType = 'Education' | 'Avinor' | 'Transport' | 'Shopping' | 'Activity' | 'Other';

const popupContent = (poiInfo: PoiInfo) => {
    switch (getPopupType(poiInfo.typeId)) {
        case 'Education':
            return <EducationPopup key={poiInfo.id} {...poiInfo} />;
        case 'Avinor':
            return <AvinorPopup key={poiInfo.id} {...poiInfo} />;
        case 'Transport':
            return <TransportPopup key={poiInfo.id} {...poiInfo} />;
        case 'Shopping':
            return <ShoppingPopup key={poiInfo.id} {...poiInfo} />;
        case 'Activity':
            return <ActivityPopup key={poiInfo.id} {...poiInfo} />;
        default:
            return <DefaultPopup key={poiInfo.id} {...poiInfo} />;
    }
};
export const PoiPopup = ({ listDisplayPoi }: PoiInfoList) => (
    <div>{listDisplayPoi.map((poi) => ({ ...poi, iconUrl: replaceMapApiUrl(poi.iconUrl) })).map((poi) => popupContent(poi))}</div>
);

const getPopupType = (poiType: number): PopupType => {
    switch (poiType) {
        case PoiTypes.SCHOOL_ELEMENTARY:
        case PoiTypes.SCHOOL_MIDDLE:
        case PoiTypes.SCHOOL_HIGH:
        case PoiTypes.KINDERGARDEN:
            return 'Education';
        case PoiTypes.ENTUR_AIRPORT:
        case PoiTypes.ENTUR_BUS:
        case PoiTypes.ENTUR_FERRY:
        case PoiTypes.ENTUR_SUBWAY:
        case PoiTypes.ENTUR_TRAIN:
        case PoiTypes.ENTUR_TRAM:
            return 'Transport';
        case PoiTypes.AVINOR_AIRPORT:
            return 'Avinor';
        case PoiTypes.SHOPPING_CENTRE:
        case PoiTypes.STORE:
        case PoiTypes.POST_OFFICE:
        case PoiTypes.PHARMACY:
        case PoiTypes.VINMONOPOL:
        case PoiTypes.KIOSK:
        case PoiTypes.GAS_STATION:
            return 'Shopping';
        case PoiTypes.SPORTS_FACILITY:
        case PoiTypes.GYM:
        case PoiTypes.SKI_CENTRE:
            return 'Activity';
        default:
            return 'Other';
    }
};
